import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Footer from "pages/Footer";
import { iniciarMatomo } from "./utils/matomo";

// Reporta en los entornos desplegados (dev y producción), no al correr en local:
// NODE_ENV lo fija CRA, es "development" con `npm start` y "production" en el build.
// dev y producción se distinguen por `environment`, no por si Sentry arranca o no.
if (process.env.REACT_APP_SENTRY && process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY,
    environment: process.env.REACT_APP_SENTRY_ENV || "production",
    integrations: [new Integrations.BrowserTracing()],
    autoSessionTracking: false,
    // Scripts que inyectan Brave y Firefox en iOS (modo lectura), no son del flow (GESTDOC-FLOW-FRONTEND-7 y 8)
    ignoreErrors: [/__firefox__/],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

// Matomo (embudo de conversión): se inicia antes de montar React; las vistas las registra cada ruta
iniciarMatomo();

ReactDOM.render(
  <React.StrictMode>
    <App />
    <Footer />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
